import { Link } from "react-router-dom";
import { getCategoryName, getHotArticles, getLatestArticles } from "@/utils/news";

const featured = getLatestArticles(1)[0];
const latestList = getLatestArticles(7).slice(1);

export default function HeroSection() {
  const hotTop = getHotArticles(1)[0];

  return (
    <section aria-label="头条推荐" className="mx-auto max-w-[1400px] px-4 pt-6 md:px-6">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <Link
            to={`/article/${featured.id}`}
            className="group relative block h-[420px] w-full overflow-hidden rounded-lg md:h-[520px]"
          >
            <img
              src={featured.image}
              alt={`${featured.title} - 51cg网头条配图`}
              title={`${featured.title} 51cg网`}
              className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
              <div className="mb-3 flex flex-wrap items-center gap-2">
                <span className="flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  <i className="ri-fire-fill" />
                  今日头条
                </span>
                <span className="rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-800">
                  {getCategoryName(featured.category)}
                </span>
              </div>
              <h2 className="max-w-3xl font-serif-cn text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                {featured.title}
              </h2>
              <p className="mt-3 max-w-2xl line-clamp-2 text-sm text-background-200 md:text-base">
                {featured.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-300">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line" />
                  {featured.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" />
                  {featured.publishedAt}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-timer-line" />
                  {featured.readTime}
                </span>
              </div>
            </div>
          </Link>
        </div>

        <aside className="flex flex-col gap-4">
          <div className="rounded-lg bg-primary-950 p-5 text-background-100">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-xs font-medium text-accent-300">
                <i className="ri-flashlight-fill" />
                正在刷屏
              </span>
              <span className="text-xs text-background-400">{hotTop.hot}° 热度</span>
            </div>
            <h2 className="mt-3 font-serif-cn text-lg font-semibold leading-snug text-background-50">
              <Link to={`/article/${hotTop.id}`} className="transition hover:text-accent-300">
                {hotTop.title}
              </Link>
            </h2>
            <p className="mt-2 line-clamp-2 text-sm text-background-300">{hotTop.summary}</p>
          </div>

          <div className="flex-1 rounded-lg border border-background-200 bg-background-100 p-5">
            <h2 className="mb-3 flex items-center gap-2 font-serif-cn text-base font-bold text-foreground-950">
              <i className="ri-history-line text-primary-500" />
              最新更新
            </h2>
            <ol className="divide-y divide-background-200">
              {latestList.map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/article/${item.id}`}
                    className="group flex gap-3 py-2.5 transition hover:text-primary-600"
                  >
                    <span className="font-serif-cn text-sm font-bold text-background-400">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1">
                      <span className="line-clamp-2 text-sm leading-snug text-foreground-800 group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="mt-1 block text-xs text-foreground-500">
                        {item.publishedAt.slice(11)}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </section>
  );
}